import React, { useState } from 'react';
import TokensIcon from '@assets/images/klipshow_token.png';
import ksFetch from '@shared/ksFetch';

const AddToLibrary = ({ klip, onAdded, setShowActions }) => {
    const [currentState, setCurrentState] = useState('initial'); // 'initial', 'price', 'title', 'saving'
    const [streamerKlip, setStreamerKlip] = useState({
        price: 1,
        klip_id: klip.id,
        title: ""
    });
    const [isAdding, setIsAdding] = useState(false);


    const handlePriceNext = () => {
        setCurrentState('title');
    };

    const handleTitleBack = () => {
        setCurrentState('initial');
    };

    const addToLibrary = async () => {
        setIsAdding(true);
        setCurrentState('saving');

        const [data, response] = await ksFetch('/streamer_klips', {
            method: 'POST',
            body: JSON.stringify({
                streamer_klip: { ...streamerKlip }
            })
        });

        if (response === 200) {
            setCurrentState('saved');
            setIsAdding(false);
            onAdded && onAdded();
        } else {
            setCurrentState('title');
        }
    };

    return (
        <div className="w-full space-y-3">
            {currentState === 'initial' && (
                <>
                    <div className="text-center">
                        <label className="text-sm text-gray-300 mb-2 block">Set Klip Price</label>
                    </div>
                    <div className="flex items-center gap-2 bg-[#0f0f23] border border-[#2a2a3e] rounded-md px-3 py-2">
                        <img src={TokensIcon} alt="Tokens" className="w-5 h-5" />
                        <input
                            type="number"
                            min="1"
                            id="price"
                            value={streamerKlip.price}
                            onChange={(e) => setStreamerKlip({ ...streamerKlip, price: parseInt(e.target.value) || 1 })}
                            className="bg-transparent text-white text-sm font-medium flex-1 outline-none border-none"
                            placeholder="1"
                        />
                    </div>
                    <div className="flex gap-2">
                        <button
                            type="button"
                            className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer"
                            onClick={handlePriceNext}
                        >
                            <i data-feather="arrow-right" className="w-4 h-4"></i>
                            Next
                        </button>
                        <button
                            type="button"
                            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer"
                            onClick={() => setShowActions(false)}
                        >
                            <i data-feather="x" className="w-4 h-4"></i>
                            Cancel
                        </button>
                    </div>
                </>
            )}

            {currentState === 'title' && (
                <>
                    <div className="text-center">
                        <label className="text-sm text-gray-300 mb-2 block">
                            Set Klip Title
                            <span className="text-xs text-red-500 ml-1">
                                *
                            </span>
                        </label>
                    </div>
                    <div className="flex items-center gap-2 bg-[#0f0f23] border border-[#2a2a3e] rounded-md px-3 py-2">
                        <i data-feather="edit-3" className="w-5 h-5 text-gray-400"></i>
                        <input
                            type="text"
                            id="title"
                            value={streamerKlip.title}
                            onChange={(e) => setStreamerKlip({ ...streamerKlip, title: e.target.value })}
                            className="bg-transparent text-white text-sm font-medium flex-1 outline-none border-none"
                            placeholder="Enter klip title..."
                        />
                    </div>
                    <div className="flex gap-2">
                        <button
                            type="button"
                            className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={addToLibrary}
                            disabled={isAdding || streamerKlip.title.length < 1}
                        >
                            {isAdding ? (
                                <>
                                    <i data-feather="loader" className="w-4 h-4 animate-spin"></i>
                                    Saving...
                                </>
                            ) : (
                                <>
                                    <i data-feather="check" className="w-4 h-4"></i>
                                    Save
                                </>
                            )}
                        </button>
                        <button
                            type="button"
                            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer"
                            onClick={handleTitleBack}
                            disabled={isAdding}
                        >
                            <i data-feather="arrow-left" className="w-4 h-4"></i>
                            Back
                        </button>
                    </div>
                </>
            )}

            {currentState === 'saving' && (
                <div className="text-center py-4">
                    <div className="flex items-center justify-center gap-2 text-gray-300">
                        <i data-feather="loader" className="w-5 h-5 animate-spin"></i>
                        <span className="text-sm">Adding to your library...</span>
                    </div>
                </div>
            )}

            {currentState === 'saved' && (
                <div className="text-center py-4">
                    <div className="flex items-center justify-center gap-2 text-gray-300">
                        <i data-feather="check" className="w-5 h-5"></i>
                        Klip added to your library
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddToLibrary;